import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Pipe, Component, HostBinding, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';

class SafeHtmlPipe {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    transform(html) {
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }
}
SafeHtmlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SafeHtmlPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SafeHtmlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SafeHtmlPipe, name: "safeHtml" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SafeHtmlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'safeHtml' }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

const DEFAULT_HEADERS = ['Interface', 'Type', 'Description'];
class SeFeDocsTableComponent {
    constructor() {
        this.noHeaders = false;
    }
    getCustomClass() {
        return this.hasCustomRows(this._rows);
    }
    ngAfterViewInit() {
        const customTable = this.hasCustomRows(this._rows);
        this.rows = customTable ? this._rows : this.mapDefaultRows(this._rows);
        this.headers = customTable ? this._headers : DEFAULT_HEADERS;
    }
    mapDefaultRows(rows) {
        return rows.map(x => {
            const optional = x.required ? '' : '(Optional) ';
            return {
                Interface: x.interface,
                Type: this.getType(x),
                Description: `${optional}${x.description}`
            };
        });
    }
    getType(rowData) {
        switch (rowData.type) {
            case 'input':
                return `@Input(${rowData.value})`;
            case 'output':
                return `@Output(${rowData.value})`;
            case 'selector':
            case 'attribute':
                return `${rowData.type}`;
            default:
                return `${rowData.value}`;
        }
    }
    hasCustomRows(rows) {
        return rows.some(obj => this.customRowObj(obj));
    }
    customRowObj(obj) {
        return !(typeof obj === 'object' &&
            obj !== null &&
            'interface' in obj &&
            'type' in obj &&
            'description' in obj &&
            (Object.keys(obj).length === 4 || Object.keys(obj).length === 5));
    }
    sortNull() { return; }
}
SeFeDocsTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeDocsTableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeDocsTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeDocsTableComponent, selector: "se-fe-docs-table", inputs: { noHeaders: ["seFeDataNoHeaders", "noHeaders"], _headers: ["seFeDataHeaders", "_headers"], _rows: ["seFeDataRows", "_rows"] }, host: { properties: { "class.se-fe-docs-table-custom": "this.getCustomClass" } }, ngImport: i0, template: "<div class=\"se-fe-docs-table-container\">\n  <table class=\"se-fe-docs-table\">\n    <thead>\n      <tr class=\"se-fe-docs-table-row\" *ngIf=\"!noHeaders\">\n        <th  *ngFor=\"let column of headers\" class=\"se-fe-docs-table-header se-fe-docs-table-cell\">\n          {{ column }}\n        </th>\n      </tr>\n    </thead>\n    <tbody>\n      <ng-container *ngIf=\"!noHeaders; else noHeader\">\n        <tr *ngFor = \"let row of rows\" class=\"se-fe-docs-table-row\">\n          <td *ngFor = \"let column of headers\" class=\"se-fe-docs-table-cell\">\n            {{ row[column] }}\n          </td>\n        </tr>\n      </ng-container>\n      <ng-template #noHeader>\n        <tr *ngFor = \"let row of rows\" class=\"se-fe-docs-table-row\">\n          <td *ngFor = \"let cell of row | keyvalue: sortNull\" class=\"se-fe-docs-table-cell\" [innerHTML]=\"(cell.value + '') | safeHtml\">\n          </td>\n        </tr>\n      </ng-template>\n    </tbody>\n  </table>\n</div>\n\n", styles: [":host{font:var(--se-small-body-font);display:grid}.se-fe-docs-table-container{width:100%;overflow-x:auto}.se-fe-docs-table{width:100%;border-collapse:collapse}.se-fe-docs-table-header,.se-fe-docs-table-cell{padding:12px 15px 8px;text-align:left;min-width:175px}.se-fe-docs-table-header:nth-child(3),.se-fe-docs-table-cell:nth-child(3){min-width:250px}.se-fe-docs-table-header{--se-bg: var(--se-accent);background:var(--se-bg);color:var(--se-primary-btn-content)}.se-fe-docs-table-row:nth-child(even){--se-bg: var(--se-container-bg);background-color:var(--se-bg)}@media (min-width: 600px){.se-fe-docs-table-header,.se-fe-docs-table-cell{min-width:150px}.se-fe-docs-table-header:nth-child(3),.se-fe-docs-table-cell:nth-child(3){min-width:45%}}:host.se-fe-docs-table-custom .se-fe-docs-table-header,:host.se-fe-docs-table-custom .se-fe-docs-table-cell{min-width:unset}@media (min-width: 600px){:host.se-fe-docs-table-custom .se-fe-docs-table-header,:host.se-fe-docs-table-custom .se-fe-docs-table-cell{min-width:unset}:host.se-fe-docs-table-custom .se-fe-docs-table-header:nth-child(3),:host.se-fe-docs-table-custom .se-fe-docs-table-cell:nth-child(3){min-width:unset}}\n"], directives: [{ type: i1$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "safeHtml": SafeHtmlPipe, "keyvalue": i1$1.KeyValuePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeDocsTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-docs-table',
                    templateUrl: './se-fe-docs-table.component.html',
                    styleUrls: ['./se-fe-docs-table.component.scss'],
                }]
        }], propDecorators: { getCustomClass: [{
                type: HostBinding,
                args: ['class.se-fe-docs-table-custom']
            }], noHeaders: [{
                type: Input,
                args: ['seFeDataNoHeaders']
            }], _headers: [{
                type: Input,
                args: ['seFeDataHeaders']
            }], _rows: [{
                type: Input,
                args: ['seFeDataRows']
            }] } });

class SeFeDocsTableModule {
}
SeFeDocsTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeDocsTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeDocsTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeDocsTableModule, declarations: [SeFeDocsTableComponent, SafeHtmlPipe], imports: [CommonModule], exports: [SeFeDocsTableComponent] });
SeFeDocsTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeDocsTableModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeDocsTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SeFeDocsTableComponent, SafeHtmlPipe],
                    imports: [CommonModule],
                    exports: [SeFeDocsTableComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeDocsTableComponent, SeFeDocsTableModule };
